/*
 * URL組み立て系の共通関数
 *
 */

// 文字列の最初のスラッシュを削除
export const deleteFirstSlashs = (s: string) => s.replace(/^\/+/, "");

// 文字列の最後のスラッシュを削除
export const deleteLastSlashs = (s: string) => s.replace(/\/+$/, "");

// 環境に応じたURLを返却
export const path = (base: string, p: string) =>
  `${base}${deleteFirstSlashs(p)}`;

// URL上のハッシュをオブジェクト型で取得
export const parseHashParams = (hash: string) => {
  const params = new URLSearchParams(
    hash.startsWith("#") ? hash.slice(1) : hash,
  );
  return Object.fromEntries(params.entries());
};

/**
 * URLのパラメータを追加
 * @param url
 * @param key
 * @param value
 * @returns パラメータ追加後のURL
 */
export const appendQueryParam = (
  url: string,
  key: string,
  value: string,
): string => {
  const u = new URL(url);
  u.searchParams.set(key, value);
  return u.toString();
};

/**
 * URLのパスパラメータ (/hoge/:xxxx/fuga ) を置換
 * @param url
 * @param params
 * @returns
 */
export const buildUrl = (
  url: string,
  params: Record<string, string | number>,
): string =>
  Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`{${key}}`, String(value)),
    url,
  );
